import type {UtilaWebhookOutcome} from '@afriex/core/domain/enums';

import axios from './axios';

// Aliased to core, which now owns the Utila webhook contract shared with the
// server's `lib/clients/paymentProcessors/utila/types.ts` (core
// standardization, PR #5099). The hand-mirrored copy that used to live here
// had drifted: it was missing the `withdrawal_finalized` outcome status and
// the `withdrawal_not_terminal` / `withdrawal_hook_failed` skip reasons.
export {
  UtilaWebhookOutcomeStatus,
  UtilaWebhookSkipReason,
} from '@afriex/core/domain/enums';
export type {UtilaWebhookOutcome} from '@afriex/core/domain/enums';

export type SimulateWebhookResponse = {
  success: boolean;
  // Typed as the Utila outcome today since utila is the only processor in
  // PROCESSOR_WEBHOOKS. Widen to a union when a second processor ships.
  outcome?: UtilaWebhookOutcome;
};

export async function simulateProcessorWebhook(
  processorId: string,
  payload: unknown,
): Promise<SimulateWebhookResponse> {
  const response = await axios.post<SimulateWebhookResponse>(
    `/v2/admin/seeds/webhooks/${processorId}`,
    payload,
  );
  return response.data;
}
